import styled from "styled-components";

import { MetricContainer } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";

export const KeywordsOverviewPageTopMetricContainer = styled(MetricContainer)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-width: 222px;
    max-width: 458px;
    transition: width 0.3s linear;
    @media (max-width: 1281px) {
        width: 222px;
    }
`;

export const MetricsSpace = styled.div`
    margin: 0 12px 0 12px;
    @media (max-width: 1500px) {
        margin: 0 8.5px 0 8.5px;
    }
`;

const FlexWithSpace = styled.div<{
    width?: string;
    height?: string;
    paddingBottom?: string;
    paddingTop?: string;
}>`
    display: flex;
    justify-content: space-between;
    ${({ width }) => width && `width: ${width}`};
    ${({ height }) => height && `height:${height}`};
    ${({ paddingBottom }) => paddingBottom && `padding-bottom:${paddingBottom}`};
    ${({ paddingTop }) => paddingTop && `padding-top:${paddingTop}`};
`;

export const MetricsRow = styled(FlexWithSpace)<{ marginTop?: string; gap?: string }>`
    ${({ marginTop = "0" }) => `margin-top: ${marginTop}`};
    ${({ gap = "0" }) => `gap: ${gap}`};
`;
